import { createElement } from 'react';
import { useLocation } from 'react-router-dom';
import { defaultRender, useGlobalState } from 'piral-core';
const DefaultLayout = (props) => defaultRender(props.children);
function createPageWrapper(Routes, fallback = 'default') {
    return (props) => {
        const location = useLocation();
        const data = props.paths.find((m) => m.matcher.test(location.pathname));
        const layout = data?.meta?.layout || fallback;
        const registration = useGlobalState((s) => s.registry.pageLayouts[layout] || s.registry.pageLayouts[fallback]);
        const Layout = registration?.component || DefaultLayout;
        return createElement(Layout, props, createElement(Routes, props));
    };
}
export function getPageLayouts(items) {
    const layouts = {};
    if (items && typeof items === 'object') {
        Object.keys(items).forEach((name) => {
            layouts[name] = {
                pilet: undefined,
                component: items[name],
            };
        });
    }
    return layouts;
}
export function withPageLayouts(pageLayouts, fallback) {
    return (state) => ({
        ...state,
        components: {
            ...state.components,
            RouteSwitch: createPageWrapper(state.components.RouteSwitch, fallback),
        },
        registry: {
            ...state.registry,
            pageLayouts,
        },
    });
}
//# sourceMappingURL=utils.js.map